/**
 * IPD source reference data
 */
import type { SourceRunStatus } from '@/lib/sources/source-types';

export const sources: { id: string; type: string; name: string; domain: string; lastRunAt: string }[] = [
  {
    id: 'src-001',
    type: 'ai_analysis',
    name: 'GIZ',
    domain: 'giz.de',
    lastRunAt: '2026-02-19T08:00:00.000Z',
  },
  {
    id: 'src-002',
    type: 'ai_analysis',
    name: 'KfW Development Bank',
    domain: 'kfw.de',
    lastRunAt: '2026-02-19T08:05:00.000Z',
  },
  {
    id: 'src-003',
    type: 'ai_analysis',
    name: 'KfW Entwicklungsbank',
    domain: 'kfw-entwicklungsbank.de',
    lastRunAt: '2026-02-19T08:10:00.000Z',
  },
  {
    id: 'src-004',
    type: 'ai_analysis',
    name: 'Sequa',
    domain: 'sequa.de',
    lastRunAt: '2026-02-19T08:15:00.000Z',
  },
];

export const sourceRunStatuses: SourceRunStatus[] = [
  { sourceId: 'giz', name: 'GIZ', domain: 'giz.de', status: 'ok', lastRunAt: '2026-02-19T08:00:00Z' },
  { sourceId: 'kfw', name: 'KfW Development Bank', domain: 'kfw.de', status: 'ok', lastRunAt: '2026-02-19T08:05:00Z' },
  { sourceId: 'kfw-entwicklungsbank', name: 'KfW Entwicklungsbank', domain: 'kfw-entwicklungsbank.de', status: 'ok', lastRunAt: '2026-02-19T08:10:00Z' },
  { sourceId: 'sequa', name: 'Sequa', domain: 'sequa.de', status: 'ok', lastRunAt: '2026-02-19T08:15:00Z' },
];
